module.exports = new __parcel__URL__("AudioBriefingChangeboardingGifDark.80056ab0.gif").toString();